import { InvestorInvitationStatus, ProgrammeStatus } from '@dealstack/shared/lib/generated';
import { SecurityPill } from '@dealstack/frontend/shared/components/SecurityPill/SecurityPill.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { getProgrammeStatusLabel } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorsTable/investorsTableFilterOptions';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	invitationStatus?: InvestorInvitationStatus;
	programmeStatus?: ProgrammeStatus;
}

/**
 * Single headline status next to the investor name. Until the account is active the
 * invitation state is the only meaningful thing to show; after that the programme
 * status (joiner/holder/leaver) takes over.
 */
export const InvestorStatusBadge = ({ invitationStatus, programmeStatus }: Props) => {
	const tMipManage = useTranslationMipManage();

	const label = (() => {
		if (invitationStatus === InvestorInvitationStatus.NOT_INVITED) {
			return tMipManage('investors.table.account_status.not_invited');
		}

		if (invitationStatus && invitationStatus !== InvestorInvitationStatus.ACTIVE) {
			return tMipManage('investors.table.account_status.invited');
		}

		return programmeStatus ? getProgrammeStatusLabel(programmeStatus, tMipManage) : null;
	})();

	if (!label) {
		return null;
	}

	return (
		<SecurityPill
			label={label}
			data-testid={TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_STATUS_BADGE}
		/>
	);
};
